class ProgressBar {
    ele: HTMLElement;
    progress: 0;
    totalTime: number;
    startTime: number;
    afmId: number;
    isPaused: boolean;
    done: boolean;
    stage1Time: number;
    stage2Time: number;
    pausedElapsedTime;
    pausedProgress;
    constructor({ ele, totalTime, stage1Time, stage2Time }: { ele: HTMLElement; totalTime: number; stage1Time: number; stage2Time: number }) {
        this.ele = ele;
        this.progress = 0;
        this.totalTime = totalTime;
        this.startTime = null;
        this.afmId = null;
        this.isPaused = false;
        this.done = false;
        this.stage1Time = stage1Time;
        this.stage2Time = stage2Time;
        this.ele.style.width = "0%";
        this.start();
    }

    start() {
        this.startTime = Date.now();
        this.animate();
    }
    animate() {
        if (this.isPaused) return;
        const currentTime = Date.now();
        const elapsedTime = currentTime - this.startTime;
        // console.log(elapsedTime, '>>>elapsedTime')
        if (elapsedTime >= this.totalTime * 1000 || this.done) {
            this.setProgress(1);
            this.stop();
        } else {
            // 计算当前进度
            let progress;
            if (elapsedTime <= this.stage1Time * 1000) {
                progress = (elapsedTime / 1000) * 0.4;
            } else if (elapsedTime <= this.stage2Time * 1000) {
                progress = 0.4 + ((elapsedTime - 1000) / 1000) * 0.4;
            } else {
                progress = this.progress + (1 - this.progress) / 2;
            }
            this.setProgress(progress);
            this.afmId = requestAnimationFrame(this.animate.bind(this));
        }
    }

    setProgress(progress) {
        this.progress = progress;
        this.ele.style.width = `${this.progress * 100}%`;
    }

    stop() {
        cancelAnimationFrame(this.afmId);
        this.afmId = null;
    }

    pause() {
        this.isPaused = true;
        cancelAnimationFrame(this.afmId);
        this.afmId = null;

        // 保存暂停时的已过去时间和进度
        this.pausedElapsedTime = Date.now() - this.startTime;
        this.pausedProgress = this.progress;
    }

    resume() {
        if (this.isPaused) {
            this.isPaused = false;
            // 从暂停时的已过去时间继续
            this.startTime = Date.now() - this.pausedElapsedTime;

            // 使用保存的进度而不是从计算开始
            this.progress = this.pausedProgress;
            this.setProgress(this.progress);

            // 继续动画
            this.animate();
        }
    }
    finish() {
        this.done = true;
    }
}

export default ProgressBar;
